<template>
  <div class="partner-authorization">
    <AuthBody title="Авторизация">
      <form @submit.prevent="handleSubmit"
            class="c-form">
        <section class="group">
          <label for="email">Логин</label>
          <input id="email"
                 class="form-control--flat"
                 type="text"
                 v-model="login"
                 :readonly="loading"
                 required/>
        </section>

        <section class="group">
          <label for="password">Пароль</label>
          <input id="password"
                 class="form-control--flat"
                 type="password"
                 v-model="password"
                 :readonly="loading"
                 required/>
        </section>

        <div class="partner-authorization__error" v-if="isIncorrectParams">
          Не удается войти.
          Пожалуйста, проверьте правильность написания логина и пароля.
        </div>

        <router-link to="/restore-password" class="partner-authorization__link">
          Забыли пароль?
        </router-link>

        <section class="btn-group">
          <button class="button btn-group__submit-btn">
            Войти
            <SpinnerRing v-if="loading" color="#fff" class="btn-group__loader" />
          </button>
        </section>
      </form>
    </AuthBody>
  </div>
</template>

<script>
import AuthBody from '@/views/Authorize/components/AuthBody.vue';
import SpinnerRing from '@/components/Spinner/SpinnerRing.vue';
import { authorize } from '@/api/auth';


export default {
  components: {
    AuthBody,
    SpinnerRing,
  },

  data() {
    return {
      loading: false,
      isIncorrectParams: false,

      login: '',
      password: '',
    };
  },

  methods: {
    async handleSubmit() {
      this.isIncorrectParams = false;
      this.loading = true;

      try {
        const { data } = await authorize(this.login, this.password);

        location.href = data.redirectURL; // eslint-disable-line
      } catch (error) {
        this.login = '';
        this.password = '';
        this.isIncorrectParams = true;
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.partner-authorization {
  label {
    text-align: center;
    font-size: 18px;
  }

  a {
    color: #586bff;
  }

  &__error {
    color: #FC402F;
    font-size: 12px;
    margin-bottom: 14px;
  }
}
</style>
